import React from 'react'
import styled from 'styled-components'
import { atlTheme } from '../../../atlTheme'

interface ColoredBarProps {
  height: number
  percentageDone: number
  borderRadius?: number
}

interface BarWrapperProps {
  height: number
  borderRadius?: number
}

const ColouredBar = styled.div<ColoredBarProps>`
  background: ${atlTheme.ColorBrand1Default};
  height: ${props => props.height}px;
  width: ${props => props.percentageDone}%;
  border-radius: ${props => (props.borderRadius ? props.borderRadius : 0)}px;
`

const BarWrapper = styled.div<BarWrapperProps>`
  background: ${atlTheme.ColorBackground};
  width: 100%;
  border-radius: ${props => (props.borderRadius ? props.borderRadius : 0)}px;
`

export interface PercentageBarProps {
  height: number
  percentageDone: number
  borderRadius?: number
  marginRight?: number
  marginLeft?: number
  marginBottom?: number
}

export const PercentageBar: React.FunctionComponent<PercentageBarProps> = ({
  percentageDone,
  height,
  borderRadius,
}) => {
  return (
    <BarWrapper height={height} borderRadius={borderRadius}>
      <ColouredBar height={height} percentageDone={percentageDone} borderRadius={borderRadius} />
    </BarWrapper>
  )
}
